import { useEffect, useState } from "react";
import { motion } from "framer-motion";

const API = process.env.REACT_APP_API_URL;

export default function Reservations() {
  const [tours, setTours] = useState([]);
  const [cart, setCart] = useState({});
  const [coupon, setCoupon] = useState("");
  const [discount, setDiscount] = useState(0);
  const [loading, setLoading] = useState(false);
  const [loadingTours, setLoadingTours] = useState(true);

  /* ===== LOAD TOURS ===== */
  useEffect(() => {
    fetch(`${API}/prod/tours`)
      .then((r) => r.json())
      .then((data) => {
        setTours(Array.isArray(data) ? data : []);
      })
      .catch(() => setTours([]))
      .finally(() => setLoadingTours(false));
  }, []);

  /* ===== CART ===== */
  const add = (id) =>
    setCart((c) => ({ ...c, [id]: (c[id] || 0) + 1 }));

  const remove = (id) =>
    setCart((c) => ({ ...c, [id]: Math.max((c[id] || 0) - 1, 0) }));

  const items = tours
    .filter((t) => cart[t.id])
    .map((t) => ({
      tour_id: t.id,
      name: t.name,
      qty: cart[t.id],
      price: Number(t.price)
    }));

  const subtotal = items.reduce(
    (s, i) => s + i.qty * i.price,
    0
  );

  const total = subtotal - discount;

  /* ===== COUPONS ===== */
  const applyCoupon = () => {
    if (coupon === "PROMO100" && subtotal >= 500) {
      setDiscount(100);
    } else {
      alert("Cupón inválido");
      setDiscount(0);
    }
  };

  /* ===== CHECKOUT ===== */
  const checkout = async () => {
    if (!items.length) return alert("Carrito vacío");

    setLoading(true);

    /* 1️⃣ Crear reserva */
    const res = await fetch(`${API}/reservations`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        items,
        coupon,
        discount
      })
    });

    const reservation = await res.json();

    /* 2️⃣ Crear pago Clip */
    const pay = await fetch(`${API}/payments/clip`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        reservation_id: reservation.reservation_id,
        amount: reservation.total,
        success_url: window.location.href
      })
    });

    const clip = await pay.json();

    /* 3️⃣ Redirigir a Clip */
    window.location.href = clip.payment_url;
  };

  /* ===== UI ===== */
  if (loadingTours) {
    return <div style={{ padding: 40 }}>Cargando tours…</div>;
  }

  return (
    <div style={{ padding: 32, maxWidth: 900, margin: "0 auto" }}>
      <h1>Reservar Tours</h1>

      {/* ===== TOURS ===== */}
      <div
        style={{
          display: "grid",
          gridTemplateColumns: "repeat(auto-fit,minmax(260px,1fr))",
          gap: 20
        }}
      >
        {tours.map((t) => (
          <motion.div
            key={t.id}
            whileHover={{ scale: 1.02 }}
            style={{
              background: "#fff",
              padding: 20,
              borderRadius: 14,
              boxShadow: "0 4px 14px rgba(0,0,0,.08)"
            }}
          >
            <h3>{t.name}</h3>
            <strong>${t.price} MXN</strong>

            <div style={{ marginTop: 10 }}>
              <button onClick={() => remove(t.id)}>-</button>
              <span style={{ margin: "0 10px" }}>
                {cart[t.id] || 0}
              </span>
              <button onClick={() => add(t.id)}>+</button>
            </div>
          </motion.div>
        ))}
      </div>

      {/* ===== SUMMARY ===== */}
      <div
        style={{
          marginTop: 30,
          padding: 20,
          background: "#f9fafb",
          borderRadius: 14
        }}
      >
        <h3>Resumen</h3>

        {items.map((i) => (
          <div key={i.tour_id}>
            {i.qty} × {i.name} = ${i.qty * i.price}
          </div>
        ))}

        <hr />

        <div>Subtotal: ${subtotal}</div>
        <div>Descuento: -${discount}</div>
        <strong>Total: ${total}</strong>

        {/* ===== COUPON ===== */}
        <div style={{ marginTop: 10 }}>
          <input
            placeholder="Cupón"
            value={coupon}
            onChange={(e) => setCoupon(e.target.value)}
          />
          <button onClick={applyCoupon}>Aplicar</button>
        </div>

        {/* ===== PAY ===== */}
        <button
          onClick={checkout}
          disabled={loading}
          style={{
            marginTop: 20,
            padding: "14px 24px",
            fontSize: 16,
            borderRadius: 10,
            background: "#111",
            color: "#fff",
            border: "none",
            cursor: "pointer"
          }}
        >
          {loading ? "Redirigiendo a Clip…" : "Pagar con Clip"}
        </button>
      </div>
    </div>
  );
}
